<template>
  <vs-popup class="update-rm-order-pop-up"
            title="UPDATE SUNDRY ORDER"
            @close="onClickClose()"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow id="rm-order-details-update-popup">

      <div class="vx-row mb-3">
        <div class="vx-col w-full">
          <vs-table id="rm-order-item-table" :hoverFlat="true" :data="sundry_items">

            <template slot="thead">
              <vs-th width="10%" class="text-xs">ITEM CODE</vs-th>
              <vs-th width="10%" class="text-xs">ITEM STATUS</vs-th>
              <vs-th width="15%" class="text-xs">UNIT SOLD IN</vs-th>
              <vs-th width="10%" class="text-xs">QUANTITY</vs-th>
              <vs-th width="10%" class="text-xs">PRICE ({{ sundry_supplier_currency }})</vs-th>
              <vs-th width="10%"  class="justify-end ml-auto mr-0 text-xs">TOTAL PRICE Excl VAT ({{ sundry_supplier_currency }})</vs-th>
              <vs-th width="10%" class="text-xs">TOTAL VAT ({{ sundry_supplier_currency }})</vs-th>
              <vs-th width="10%" class="text-xs">ACTION</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr class="text-sm" :key="indextr" v-for="(tr, indextr) in data">

                <vs-td class="font-semibold" :data="data[indextr].sundry_item_code">
                  {{data[indextr].sundry_item_code}}
                </vs-td>

                <vs-td :data="data[indextr].item_status">
                  {{ data[indextr].item_status }}
                </vs-td>

                <vs-td :data="data[indextr].sold_in">
                  {{ data[indextr].sold_in}}
                </vs-td>

                <vs-td :data="data[indextr].quantity">
                  <vs-input  type="text" v-model="data[indextr].quantity" class="w-full"
                             :name="indextr+'quantity'" />
                </vs-td>

                <vs-td :data="data[indextr].price">
                  <!-- {{ (Number(data[indextr].price)).toFixed(2) }} -->
                  <vs-input  type="text" v-model="data[indextr].price" class="w-full"
                             :name="indextr+'quantity'" />
                </vs-td>

                <vs-td>
                  {{data[indextr].quantity ? (Number(data[indextr].price) * data[indextr].quantity).toFixed(2) : '0.00'}}
                </vs-td>

                <vs-td :data="data[indextr].vat">
                  <vs-input  type="text" v-model="data[indextr].vat" class="w-full"
                             :name="indextr+'vat'" />
                </vs-td>

                <vs-td>
                  <vx-tooltip class="mr-2" text="Update quantity" position="top">
                    <vs-button :id="'update_button'+''+ indextr"
                               @click.stop="onClickUpdateCart(data[indextr].id, data[indextr].quantity, indextr, data[indextr].vat, data[indextr].price)"
                               size="small" color="primary" type="border" icon-pack="feather" icon="icon-save"></vs-button>
                  </vx-tooltip>
                </vs-td>

              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SundrySupplierRepository = RepositoryFactory.get('sundry')

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      update_type: null,
      sundry_items: [],
      countryCodes: [],
      sundry_supplier_currency : 'GBP'
    }
  }

  export default {
    name: 'UpdateSundryOrderPopUp',
    data () {
      return initialState()
    },
    methods:{
      async openPopup (id) {
        try {
          Object.assign(this.$data, initialState())
          this.id = id
          this.open = true;
          await this.getProductOrdersOrder()
        } catch (error) {

        }
      },
      async getProductOrdersOrder() {
        await this.$vs.loading({
          container: '#rm-order-details-update-popup',
          scale: 0.45
        })
        try {
          const {data} = (await SundrySupplierRepository.getSundryOrder(this.id)).data
          this.sundry_items = data.sundry_items
          this.sundry_supplier_currency = data.sundry_supplier_currency
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#rm-order-details-update-popup > .con-vs-loading')
      },
      async onClickUpdateCart(id, qty, index, vat, price) {
        await this.$vs.loading({
          container: `#update_button${index}`,
          scale: 0.45
        })
        try {
          await SundrySupplierRepository.updateSundryItemQuantity(id, {quantity: qty, vat: Number(vat).toFixed(2), price: Number(price).toFixed(2)})
          await this.$parent.refreshData()
          this.showSuccessMessage('Sundry item updated successfully')
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close(`#update_button${index} > .con-vs-loading`)
      },
      async onClickClose() {
        this.open = false;
      }
    },
    components: {
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .update-rm-order-pop-up >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 60% !important;
  }

</style>
